<template>
  <div>
    <!-- choice -->
    <template v-if="field.type === 'choice'">
      <ChoiceField
        v-show="!field.hidden"
        ref="fieldRef"
        :dense="dense"
        :errors="errors"
        :field="field"
        :model-value="modelValue"
        :rules="rules"
        v-bind="$attrs"
        @update:model-value="$emit('update:modelValue', $event)"
      />
    </template>

    <!-- choiceCheckbox -->
    <template v-else-if="field.type === 'choiceCheckbox'">
      <ChoiceCheckboxField
        v-show="!field.hidden"
        ref="fieldRef"
        :dense="dense"
        :errors="errors"
        :field="field"
        :model-value="modelValue"
        :rules="rules"
        v-bind="$attrs"
        @update:model-value="$emit('update:modelValue', $event)"
      />
    </template>

    <!-- boolean -->
    <template v-else-if="field.type === 'boolean'">
      <BooleanField
        v-show="!field.hidden"
        ref="fieldRef"
        :dense="dense"
        :errors="errors"
        :field="field"
        :model-value="modelValue"
        :rules="rules"
        v-bind="$attrs"
        @update:model-value="$emit('update:modelValue', $event)"
      />
    </template>

    <!-- nullBoolean -->
    <template v-else-if="field.type === 'nullBoolean'">
      <NullBooleanField
        v-show="!field.hidden"
        ref="fieldRef"
        :dense="dense"
        :errors="errors"
        :field="field"
        :model-value="modelValue"
        :rules="rules"
        v-bind="$attrs"
        @update:model-value="$emit('update:modelValue', $event)"
      />
    </template>

    <!-- number -->
    <template v-else-if="field.type === 'number'">
      <NumberField
        v-show="!field.hidden"
        ref="fieldRef"
        :dense="dense"
        :errors="errors"
        :field="field"
        :model-value="modelValue"
        :rules="rules"
        v-bind="$attrs"
        @update:model-value="$emit('update:modelValue', $event)"
      />
    </template>

    <!-- date, datetime -->
    <template v-else-if="field.type === 'datetime'">
      <DatetimeField
        v-show="!field.hidden"
        ref="fieldRef"
        :dense="dense"
        :errors="errors"
        :field="field"
        :model-value="modelValue"
        :rules="rules"
        v-bind="$attrs"
        @update:model-value="$emit('update:modelValue', $event)"
      />
    </template>
    <!-- LatLng -->
    <template v-else-if="field.type === 'coordinates'">
      <CoordinatesField
        v-show="!field.hidden"
        ref="fieldRef"
        :dense="dense"
        :errors="errors"
        :field="field"
        :model-value="modelValue"
        :rules="rules"
        v-bind="$attrs"
        @update:model-value="$emit('update:modelValue', $event)"
      />
    </template>

    <!-- file, media -->
    <template v-else-if="field.type === 'file' || field.type === 'media'">
      <FileField
        v-show="!field.hidden"
        ref="fieldRef"
        :dense="dense"
        :errors="errors"
        :field="field"
        :main-value="mainValue"
        :model-value="modelValue"
        :rules="rules"
        v-bind="$attrs"
        @update:main-value="$emit('update:mainValue', $event)"
        @update:model-value="$emit('update:modelValue', $event)"
      />
    </template>

    <template v-else-if="field.type === 'user'">
      <UserField
        v-show="!field.hidden"
        ref="fieldRef"
        :dense="dense"
        :errors="errors"
        :field="field"
        :model-value="modelValue"
        :rules="rules"
        v-bind="$attrs"
        @update:model-value="$emit('update:modelValue', $event)"
      />
    </template>

    <!-- textarea -->
    <template v-else-if="field.type === 'textarea'">
      <TextareaField
        v-show="!field.hidden"
        ref="fieldRef"
        :dense="dense"
        :errors="errors"
        :field="field"
        :model-value="modelValue"
        :rules="rules"
        v-bind="$attrs"
        @update:model-value="$emit('update:modelValue', $event)"
      />
    </template>

    <!-- text + multiple -->
    <template v-else-if="field.type === 'text' && field.multiple">
      <TextMultipleField
        v-show="!field.hidden"
        ref="fieldRef"
        :dense="dense"
        :errors="errors"
        :field="field"
        :model-value="modelValue"
        :rules="rules"
        v-bind="$attrs"
        @update:model-value="$emit('update:modelValue', $event)"
      />
    </template>

    <!-- childObject -->
    <template v-else-if="field.type === 'childObject'">
      <ChildObjectField
        v-show="!field.hidden"
        ref="fieldRef"
        :dense="dense"
        :errors="errors"
        :field="field"
        :model-value="modelValue"
        :rules="rules"
        v-bind="$attrs"
        @update:model-value="$emit('update:modelValue', $event)"
      />
    </template>

    <!-- number, street, postal_community, state, postal_code, coordinates -->
    <template v-else-if="field.type === 'address'">
      <AddressField
        v-show="!field.hidden"
        ref="fieldRef"
        :dense="dense"
        :errors="errors"
        :field="field"
        :model-value="modelValue"
        :rules="rules"
        v-bind="$attrs"
        @update:model-value="$emit('update:modelValue', $event)"
      />
    </template>

    <!-- vehicle -->
    <template v-else-if="field.type === 'vehicle'">
      <VehicleField
        v-show="!field.hidden"
        ref="fieldRef"
        :dense="dense"
        :field="field"
        :model-value="modelValue"
        v-bind="$attrs"
        @update:model-value="$emit('update:modelValue', $event)"
      />
    </template>

    <!-- richtext -->
    <template v-else-if="field.type === 'richtext'">
      <v-card class="mt-2">
        <RichtextField
          v-show="!field.hidden"
          ref="fieldRef"
          :dense="dense"
          :field="field"
          :model-value="modelValue"
          :readonly="false"
          v-bind="$attrs"
          @update:model-value="$emit('update:modelValue', $event)"
        />
      </v-card>
    </template>

    <!-- text, email, phone, phoneWithExt -->
    <template v-else>
      <TextField
        v-show="!field.hidden"
        ref="fieldRef"
        :dense="dense"
        :errors="errors"
        :field="field"
        :model-value="modelValue"
        :rules="rules"
        v-bind="$attrs"
        @update:model-value="$emit('update:modelValue', $event)"
      />
    </template>
  </div>
</template>

<script setup lang="ts">
import {
  AddressField,
  ChoiceField,
  DatetimeField,
  FileField,
  NullBooleanField,
  NumberField,
  TextField,
  TextMultipleField,
  TextareaField,
  UserField,
  VehicleField,
} from '#components';

type Field = typeof ChoiceField |
  typeof AddressField |
  typeof DatetimeField |
  typeof FileField |
  typeof NullBooleanField |
  typeof NumberField |
  typeof TextField |
  typeof TextMultipleField |
  typeof TextareaField |
  typeof UserField |
  typeof VehicleField;

defineProps<{
  field: FieldConfig
  mainValue?: any
  modelValue: any
  errors?: string[]
  rules?: FormRule[]
  dense?: boolean
}>();
defineEmits(['update:modelValue', 'update:mainValue']);

const fieldRef = ref<InstanceType<Field>>();
const reset = () => {
  if (
    fieldRef.value &&
    'reset' in fieldRef.value &&
    typeof fieldRef.value.reset === 'function'
  ) {
    fieldRef.value.reset();
  }
};

defineExpose({ reset });
</script>
